import { render } from "./formSelector.vue?vue&type=template&id=085c35bb"
import script from "./formSelector.vue?vue&type=script&lang=js"
export * from "./formSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__